import React, { Component } from 'react';
import {BrowserRouter as Router} from 'react-router-dom';
import * as Constants from '../../common/Global/constants';
import {TableCheckBox,CustomTableRow,AddNewButtonLayout,
    DialogSaveButton,DialogProceedButton,TableRadioButton} from '../../common/Global/globalStyles.style';
import {getLocalStorageVariables,getThemeSettingsVariables,isEmptyVariable,
    removeHtmlTags,isEmptyArray, getStatusSpan,
    handleTokenExpiry} from '../../common/Global/commonFunctions';
import RegularDropdown from '../../common/DropdownMenus/RegularDropdown';
import {Accordion, Button, Card, Modal} from 'react-bootstrap';
import FilterDropDown from "../../common/DropdownMenus/FilterDropdown";
import AlertDialog from '../../common/AlertDialog';
import { DatePicker } from 'antd';
import moment from 'moment';

let userDetails = getLocalStorageVariables();
let themeSettings = getThemeSettingsVariables();
const resourceDropdownPlaceholder="Select Employee";

class ReAssignForResponse extends Component {
    constructor(props) {
        super(props);
        this.state = {
            componentDidMountFlag:false,
            datalist:[],
            showLoader:false,

            employeesList:[],

            showAlertDialogInfo:false,
            alertDialogMessageInfo:"",

            showAssignResourcesDialogFlag:false,
            resourceDropdownPlaceholder:"Select Employee",

            filterDataList: [],
            FilterDropDownArr: [],
            FilterPlaceholder: "All",

            assigneResourcesFilterDropDownArr :[],
            assigneResourcesFilterDataList:[],
            assignResourcesPlaceholder:"All",
            activeKey: null,
            activeAssignResourceKey: null
        }
        userDetails = getLocalStorageVariables();
        themeSettings = getThemeSettingsVariables();
    }

    componentDidMount(){
        this.getInitData();
    }

    getRootLevelFunctions = (functionMapTemp) => {
        let rootFunctionArr = [];
        Object.values(functionMapTemp).map((item)=>{
            if(item.level === 0){
                rootFunctionArr.push(item);
            }
        })
        return rootFunctionArr;
    }

    handleStopPropagation = (e) => {
        e.stopPropagation();
    }

    // Tasks to Assignment Selection
    handleSelectionTask = (e) => {
        e.stopPropagation();
        let isChecked = e.target.checked;
        let indexAndProcessId = e.target.name;
        let [index, processId] = indexAndProcessId.split(":-:");

        const newDataList = this.state.datalist.map(process => {
            let id = isEmptyVariable(process.processId) ? process.functionId : process.processId;
            if (String(id) === String(processId)) {
                // Update the selected task in the correct process
                const newTaskList = process.taskList.map((task, idx) => {
                    if (String(idx) === String(index)) {
                        return { ...task, isSelected: isChecked };
                    }
                    return task;
                });
                // Check if all tasks are selected
                const allSelected = newTaskList.every(task => task.isSelected);
                return {
                    ...process,
                    taskList: newTaskList,
                    isProcSelected: allSelected
                };
            }
            return process;
        });

        this.setState({
            datalist: newDataList
        });
    }

    handleSelectionProcessTasks = (e) => {
        e.stopPropagation();
        let isChecked = e.target.checked;
        let processId = e.target.name;
        // let id = isEmptyVariable(process.processId) ? process.functionId : process.processId;

        // Use map to create a new datalist array
        const newDataList = this.state.datalist.map(process => {
            if (String(processId) === String(process.processId)) {
                return {
                    ...process,
                    isProcSelected: isChecked,
                    taskList: process.taskList.map(item => ({
                        ...item,
                        isSelected: isChecked
                    }))
                };
            }
            return process;
        });

        this.setState({
            datalist: newDataList
        });
    }

    selectAll = () => {
        const newDataList = this.state.datalist.map(process => ({
        ...process,
            isProcSelected: true,
            taskList: process.taskList.map(task => ({
                ...task,
                isSelected: true
            }))
        }));
        this.setState({
            datalist: newDataList
        });
    }

    unSelectAll = () => {
        const newDataList = this.state.datalist.map(process => ({
            ...process,
            isProcSelected: false,
            taskList: process.taskList.map(task => ({
                ...task,
                isSelected: false
            }))
        }));
        this.setState({
            datalist: newDataList
        });
    }

    onClickAddToAssignment = () => {
        const newDataList = this.state.datalist.map(process => ({
            ...process,
            taskList: process.taskList.map(task => ({
                ...task,
                added: task.isSelected ? true : task.added
            }))
        }));
        this.setState({
            datalist: newDataList
        });
    }

    onClickRemoveFromAssignment = () => {
        const newDataList = this.state.datalist.map(process => ({
            ...process,
            taskList: process.taskList.map(task => ({
                ...task,
                added: task.isSelected ? false : task.added
            }))
        }));
        this.setState({
            datalist: newDataList
        });
    }

    handleAccordionToggle = (eventKey) => {
        if (this.state.activeKey === eventKey) {
            this.setState({ activeKey: null });
        } else {
            this.setState({ activeKey: eventKey });
        }
    }

    handleAccordionToggleAssignResource = (eventKey) => {
        if (this.state.activeAssignResourceKey === eventKey) {
            this.setState({ activeAssignResourceKey: null });
        } else {
            this.setState({ activeAssignResourceKey: eventKey });
        }
    }

    filterDropDownOnClick = (selectedItem) =>{
        let tempFilterDataList =[];
        let tempFilterDataArray = this.state.FilterDropDownArr;
        if(selectedItem.label==="All"){
            this.setState({
                filterDataList:[],
            })
        }else{
            Object.values(this.state.datalist).map((item)=>{
                if(selectedItem.label === item.processName){
                    tempFilterDataList.push(item)
                }
            })
        }
        tempFilterDataArray.map((item) => {
            if (item.label === selectedItem.label) {
                item.isSelected = true;
            } else {
                item.isSelected = false;
            }
        });

        this.setState({
            filterDataList:tempFilterDataList,
            FilterDropDownArr:tempFilterDataArray,
            FilterPlaceholder:selectedItem.label
        })
    }

    handleAlertDialogCloseInfo = () => {
        this.setState({
            showAlertDialogInfo:false,
            alertDialogMessageInfo:""
        })
    }

    resourceDropdownClick = (resource) => {
        let resourceCount = 0;
        const newDataList = this.state.datalist.map(process => ({
            ...process,
            isProcSelectedInResources: false,
            taskList: process.taskList.map(task => {
                if (task.isEmployeeTaskSelected) {
                    resourceCount += 1;
                    return {
                        ...task,
                        addedEmployeeToAssignment: true,
                        employeeId: resource.employeeId,
                        employeeFullName: resource.fullName,
                        employeeType: resource.employeeType,
                        isEmployeeTaskSelected: false
                    };
                }
                return {
                    ...task,
                    isEmployeeTaskSelected: false
                };
            })
        }));
        if (resourceCount > 0) {
            this.setState({
                showAlertDialogInfo: true,
                alertDialogMessageInfo: `${resourceCount} tasks have been allocated to ${resource.fullName}`,
            });
        }
        this.setState({
            datalist: newDataList,
            resourceCount: resourceCount
        });
    }

    handleSelectionTaskInResourcesDialog = (e) => {
        e.stopPropagation();

        let isChecked = e.target.checked;
        let indexAndProcessId = e.target.name;
        let [index, processId] = indexAndProcessId.split(":-:");
        
        const newDataList = this.state.datalist.map(process => {
            let id = isEmptyVariable(process.processId) ? process.functionId : process.processId;
            if (String(id) === String(processId)) {
                const newTaskList = process.taskList.map((task, idx) => {
                    if (String(idx) === String(index)) {
                        return { ...task, isEmployeeTaskSelected: isChecked };
                    }
                    return task;
                });
                // Check if all tasks are selected
                const allSelected = newTaskList.every(task => task.isEmployeeTaskSelected);
                return {
                    ...process,
                    taskList: newTaskList,
                    isProcSelectedInResources: allSelected
                };
            }
            return process;
        });

        this.setState({
            datalist: newDataList
        });
    }

    handleSelectionProcessTasksInResourcesDialog = (e) => {
        e.stopPropagation();
        let isChecked = e.target.checked;
        let processId = e.target.name;

        const newDataList = this.state.datalist.map(process => {
            let id = isEmptyVariable(process.processId) ? process.functionId : process.processId;
            if (String(id) === String(processId)) {
                return {
                    ...process,
                    isProcSelectedInResources: isChecked,
                    taskList: process.taskList.map(task => ({
                        ...task,
                        isEmployeeTaskSelected: isChecked
                    }))
                };
            }
            return process;
        });

        this.setState({
            datalist: newDataList
        });
    }

    selectAllTasksResourcesDialog = () => {
        const newDataList = this.state.datalist.map(process => ({
            ...process,
            isProcSelectedInResources: true,
            taskList: process.taskList.map(task => ({
                ...task,
                isEmployeeTaskSelected: task.added ? true : false
            }))
        }));
        this.setState({
            datalist: newDataList
        });
    }

    unSelectAllTasksResourcesDialog = () => {
        const newDataList = this.state.datalist.map(process => ({
            ...process,
            isProcSelectedInResources: false,
            taskList: process.taskList.map(task => ({
                ...task,
                isEmployeeTaskSelected: false
            }))
        }));
        this.setState({
            datalist: newDataList
        });
    }

    assignResourcesDialogClose = () => {
        this.unSelectAllTasksResourcesDialog();
        this.setState({
            datalist:this.state.oldDataList,
            showAssignResourcesDialogFlag:false,
            activeAssignResourceKey:null
        })
    }

    onClickNextButton = () => {
        this.setState({
            showLoader:true
        })

        let isError = true;
        // let formErr = {};
        // formErr.assignTaskErr = "Please add atleast one task to the assignment"

        this.state.datalist.map(processObj=>{
            processObj.taskList.map(item=>{
                if(item.added){
                    isError = false;
                }
            })
        })

        let tempFilterArray = [
            {
                label: "All",
                isSelected: true,
            },
        ];
            
        this.state.datalist.map((processObj)=>{
            let showTasks=(processObj.taskList).some((item) =>item.added===true);
            if(showTasks){
                tempFilterArray.push({
                    label:processObj.processName,
                    isSelected:false
                })
            }
        })

        let oldDataList = JSON.parse(JSON.stringify(this.state.datalist));
        //now do the validation
        if(isError){
            this.setState({
                showLoader:false,
                showAlertDialogInfo:true,
            	alertDialogMessageInfo:"Please add atleast one task to the assignment"
            });
        }else{
            this.setState({
                showAssignResourcesDialogFlag:true,
                showLoader:false,
                oldDataList:oldDataList,
                assigneResourcesFilterDataList:[],
                assigneResourcesFilterDropDownArr:tempFilterArray,
                assignResourcesPlaceholder:"All"
            })
        }
    }

    assigneResourceFilterDropDownOnClick = (selectedItem) =>{
        let tempFilterDataList =[];
        let tempFilterDataArray = this.state.assigneResourcesFilterDropDownArr;
        if(selectedItem.label==="All"){
            this.setState({
                filterDataList:[],
            })
        }else{
            Object.values(this.state.datalist).map((item)=>{
                if(selectedItem.label === item.processName){
                    tempFilterDataList.push(item)
                }
            })
        }
        tempFilterDataArray.map((item) => {
            if (item.label === selectedItem.label) {
                item.isSelected = true;
            } else {
                item.isSelected = false;
            }
        });

        this.setState({
            assigneResourcesFilterDataList:tempFilterDataList,
            assigneResourcesFilterDropDownArr:tempFilterDataArray,
            assignResourcesPlaceholder:selectedItem.label
        })
    }

    onClickAddResourceToAssignment = () => {
        let isError = false;
        Object.values(this.state.datalist).forEach(processObj=>{
            processObj.taskList.forEach(item=>{
                if(item.added && isEmptyVariable(item.employeeId)){
                    isError = true;
                }else{
                    
                }
            })
        })

        if(isError){
            this.setState({
                showAlertDialogInfo:true,
                alertDialogMessageInfo:"Please add resource to all the tasks"
            })
        }else{
            //now parse the array
            let assignmentTasks = []
            Object.values(this.state.datalist).forEach(processObj=>{
                processObj.taskList.forEach(item=>{
                    if(item.added && !isEmptyVariable(item.employeeId)){
                        let obj = {
                            employeeId:item.employeeId,
                            employeeType:item.employeeType
                        }

                        if(!isEmptyVariable(item.assignmentTaskId)){
                            obj.assignmentTaskId = item.assignmentTaskId;
                        }
                        if(!isEmptyVariable(item.observationId)){
                            obj.observationId = item.observationId;
                        }
                        assignmentTasks.push(obj);
                    }
                })
            })

            this.setState({
                showNextDateDialog:true,
                assignmentTasks:JSON.stringify(assignmentTasks)
            })
        }
    }

    handleDateDialogClose = () => {
        this.setState({
            showNextDateDialog:false,
            assignmentTasks:[]
        })
    }

    handleClear = () => {
        this.setState({
            deadlineDate:null,
            selectedOption:""
        })
    }

    // if onDateChange already exists, replace it; otherwise add this handler
    onDateChange = (date, dateString) => {
        // when user picks a date, clear radio selection so radios become disabled
        this.setState({
            deadlineDate:isEmptyVariable(date)?null:date.format("YYYY-MM-DD")
        })
    }

    handleCheck = (e) =>{
        let selectedOption = e.target.value;
        let FormErrorsTemp = this.state.formErrors;

        if(this.state.submitClickedAtleastOnce){
            FormErrorsTemp['option'] = "";
        }

        this.setState({
            selectedOption
        })
    }

    /*******************API CALLS*******************/
    getInitData = () => {
        this.setState({
            showLoader:true,
        });

        Promise.all([
            fetch(Constants.GetAuditeeEmployeeDraftReports+"/"+this.props.assignmentId+"/tasks", {
                method: "POST",
                mode: "cors",
                body: new URLSearchParams({
                    email: userDetails.email,
                    accessToken: userDetails.accessToken,
                }),
            }),
            fetch(Constants.EmployeeOrAuditeeList,{
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    assignmentId:this.props.assignmentId,
                    userType:'ae'
                })
            })
        ])
        .then(([masterRes, empAudRes]) => { 
            return Promise.all([masterRes.json(), empAudRes.json()]) 
        })
        .then(([masterRes,empAudRes]) => {
            let draftAssignmentAuditeeList = [];
            let clientEmployeeList = [];
            let employeesList = [];
            let empList = [];
            let datalistTemp = [];
            let taskTemplateValueMap = {};
            if(handleTokenExpiry(masterRes.responseCode)) return;
            else if (masterRes.responseCode === Constants.CODE_SUCCESS) {
                datalistTemp = masterRes.data.assignedTaskList;
                taskTemplateValueMap = masterRes.data.taskTemplateValueMap;
            } else {
            }

            if(handleTokenExpiry(empAudRes.responseCode)) return;
            else if(empAudRes.responseCode === Constants.CODE_SUCCESS){
                draftAssignmentAuditeeList = empAudRes.data.draftAssignmentAuditeeList;
                clientEmployeeList = empAudRes.data.clientEmployeeList;

                const matchingAssignmentUnit = clientEmployeeList.filter(emp => {
                    const unitId = JSON.parse(emp.unit)[0]; 
                    return this.props.unitListId.includes(unitId);
                });

                const otherEmployees = clientEmployeeList.filter(emp => {
                    const unitId = JSON.parse(emp.unit)[0];
                    return !this.props.unitListId.includes(unitId);
                });

                const finalList = [...matchingAssignmentUnit, ...otherEmployees];

                let employees = [...draftAssignmentAuditeeList,...finalList];

                employeesList = employees.map(emp => ({
                    ...emp,
                    userName: `${emp.firstName} ${emp.lastName}`,
                    fullName:`${emp.firstName} ${emp.lastName} (${emp.designation})`
                }));
                empList = employeesList.filter(item => item.employeeEmail !== userDetails.email);
            }else{

            }

            let tempFilterArray = [
                {
                  label: "All",
                  isSelected: true,
                },
            ];
            datalistTemp.map((processObj)=>{
                tempFilterArray.push({
                    label:processObj.processName,
                    isSelected:false
                })
            })
            this.setState({
                datalist: datalistTemp,
                taskTemplateValueMap:taskTemplateValueMap,
                showLoader:false,
                componentDidMountFlag:true,
                FilterDropDownArr:tempFilterArray,
                employeesList:empList
            })
        })
    }

    handleProceedButtonClick = () => {
        let isError = false;
        if(isEmptyVariable(this.state.deadlineDate) && isEmptyVariable(this.state.selectedOption)){
            isError = true;
        }
        if(isError){
            this.setState({
                errorMsg:"Please select a date",
                showLoader:false
            });

            setTimeout(() => {
                this.setState({
                    formErrors:{},
                });
            },Constants.WRNG_MSG_TIMEOUT);
        }else{
            let deadlineDate = "";
            if(!isEmptyVariable(this.state.selectedOption)){
                const days = parseInt(this.state.selectedOption);
                deadlineDate = moment().add(days + 1, 'days').startOf('day').toISOString();
            }else{
                deadlineDate = moment(this.state.deadlineDate, 'YYYY-MM-DD').startOf('day').toISOString();
            }

            //call the fetch function
            fetch(Constants.ReAssign,
            {
                method: "POST",
                mode:'cors',
                body: new URLSearchParams({
                    email:userDetails.email,
                    accessToken:userDetails.accessToken,
                    aeList:this.state.assignmentTasks,
                    assignmentId:this.props.assignmentId,
                    clientResponseDeadline:deadlineDate
                })
            })
            .then(response => { return response.json(); } )
            .then(data =>
            {
                if(handleTokenExpiry(data.responseCode)) return;
                else if(data.responseCode === Constants.CODE_SUCCESS){
                    this.handleDateDialogClose();
                    this.assignResourcesDialogClose();
                    this.handleClear();
                    this.unSelectAll();
                    this.getAuditeeEmployeeDraftReports();
                }else{
                    this.setState({
                        showAlertDialogInfo:true,
                        alertDialogMessageInfo:data.responseMessage
                    })
                }
            });
        }
    }

    getAuditeeEmployeeDraftReports = () => {
        fetch(Constants.GetAuditeeEmployeeDraftReports+"/"+this.props.assignmentId+"/tasks", {
            method: "POST",
            mode: "cors",
            body: new URLSearchParams({
                email: userDetails.email,
                accessToken: userDetails.accessToken,
            }),
        })
        .then(response => { return response.json(); } )
            .then(data =>
            {
                if(handleTokenExpiry(data.responseCode)) return;
                else if(data.responseCode === Constants.CODE_SUCCESS){
                    let datalistTemp = data.data.assignedTaskList;
                    let taskTemplateValueMap = data.data.taskTemplateValueMap;

                    this.setState({
                        datalist: datalistTemp,
                        taskTemplateValueMap:taskTemplateValueMap
                    })
                }
            }
        )
    }
    /*******************API CALLS END HERE*******************/

    render() {
        return(
            <Router>
                {
                    this.state.componentDidMountFlag &&
                    <div className="m-t-10">
                        {
                            this.state.showLoader &&
                            <div class="loader"></div>
                        }
                        <div className="prev-next-layout">
                            <div className="flex-center-layout secondary-top-bar">
                                <div className="back-btn-layout" onClick={() => {
                                    this.props.handleReAssignForResponseDialogClose(true);
                                }}>
                                <span class="material-icons-outlined">arrow_back_ios</span>
                                </div>
                                <h6>{"Re-Assign For Response"}</h6>
                            </div>
                            <div className="flex-center-layout">
                                <div style={{ marginRight: 10 }}>
                                    <FilterDropDown
                                        placeholder={this.state.FilterPlaceholder}
                                        dropdownArr={this.state.FilterDropDownArr}
                                        onDropDownItemClick={this.filterDropDownOnClick}
                                        themeSettings={themeSettings}
                                        name={"label"}
                                        dropdownWidth="200px"
                                    />
                                </div>
                                <div className="bordered-anchor"
                                style={{marginRight:5}}>
                                    <a onClick={this.unSelectAll} href="javascript:void(0);">
                                        <span class="material-icons-outlined">
                                        check_box_outline_blank
                                        </span>
                                        <p>Unselect All</p>
                                    </a>
                                </div>
                                <div className="bordered-anchor"
                                style={{marginRight:5}}>
                                    <a onClick={this.selectAll} href="javascript:void(0);">
                                        <span class="material-icons-outlined">
                                        check_box
                                        </span>
                                        <p>Select All</p>
                                    </a>
                                </div>
                                <AddNewButtonLayout themeSettings={themeSettings}
                                style={{marginRight:5}}>
                                    <a onClick={this.onClickRemoveFromAssignment} href="javascript:void(0);">
                                        <span className="material-icons">remove_circle_outline</span>
                                        <p>Remove</p>
                                    </a>
                                </AddNewButtonLayout>
                            
                                <AddNewButtonLayout themeSettings={themeSettings}>
                                    <a onClick={this.onClickAddToAssignment} href="javascript:void(0);">
                                        <span className="material-icons">add_circle</span>
                                        <p>Add to Assignment</p>
                                    </a>
                                </AddNewButtonLayout>
                            
                                <AddNewButtonLayout themeSettings={themeSettings} style={{marginLeft:5}}>
                                    <a onClick={this.onClickNextButton} href="javascript:void(0);">
                                        {/* <span className="material-icons">add_circle</span> */}
                                        <p>Next</p>
                                        <span class="material-icons-outlined">arrow_forward_ios</span>
                                    </a>
                                </AddNewButtonLayout>
                            </div>
                        </div>
                        <div className="assign-tasks-layout accordion-layout">
                            {(isEmptyArray(this.state.filterDataList)?this.state.datalist:this.state.filterDataList).map((processObj,index)=>{
                                    let className;
                                    if (index === 0) {
                                        className = 'card-radius'; // CSS for the first item
                                    } else if (index === ((isEmptyArray(this.state.filterDataList)?
                                    this.state.datalist:this.state.filterDataList).length - 1)) {
                                        className = 'card-last'; // CSS for the last item
                                    } else {
                                        className = 'card-middle'; // CSS for all other items
                                    }
                                    let id = isEmptyVariable(processObj.processId) ? processObj.functionId : processObj.processId;
                                    return <div className="process-task-list">
                                        <Accordion style={{marginTop:index === 0?15:0}} activeKey={this.state.activeKey}>
                                            <Card className={className}> 
                                                <Card.Header>
                                                    <Accordion.Toggle
                                                        as={Button}
                                                        variant="link"
                                                        eventKey={id}
                                                        onClick={() => this.handleAccordionToggle(id)}
                                                    >
                                                        <div className='row align-items-center'>
                                                            <TableCheckBox onClick={this.handleStopPropagation}
                                                                themeSettings={themeSettings}>
                                                                <input 
                                                                    type="checkbox"
                                                                    name={id}
                                                                    id={id}
                                                                    onChange={this.handleSelectionProcessTasks}
                                                                    checked={processObj.isProcSelected?true:false}
                                                                />
                                                                <label for={id} 
                                                                style={{marginLeft:-3}}></label>
                                                            </TableCheckBox>
                                                            <h6 className='col-md-6 text-left'>{!isEmptyVariable(id)?processObj.processName:processObj.functionName}</h6>
                                                                {
                                                                    processObj.count > 0 &&
                                                                    <h6 className='col-md-2 text-left'>{"Total Task: "+processObj.count}</h6>
                                                                }
                                                            <h6 className='col-md-3 text-center'>{"Added to Assignment: "+processObj.taskList.filter(item => item.added == true).length}</h6>
                                                        </div>
                                                    </Accordion.Toggle>
                                                </Card.Header> 
                                                <Accordion.Collapse eventKey={id}>
                                                    <Card.Body>
                                                        {
                                                            !isEmptyArray(processObj.taskList) && 
                                                            <div className="common-tab-bg">
                                                                <div class="common-table" style={{width: "100%", borderRadius: "4px"}}>
                                                                    <div className="table-custom-layout">
                                                                        <div className="table-custom-header">
                                                                            <div className="table-custom-header-row">
                                                                                <p style={{width:"5%"}}></p>
                                                                                <p style={{width:"5%",justifyContent:"center"}}>No</p>
                                                                                <p style={{width:"82%"}}>Task</p>
                                                                                {/* <p style={{width:"30%"}}>Employee</p> */}
                                                                                <p style={{width:"8%"}}>Added</p>
                                                                                
                                                                            </div>
                                                                        </div>
                                                                        
                                                                        <div className="table-custom-body">
                                                                        {
                                                                            !isEmptyArray(processObj.taskList) && 
                                                                            processObj.taskList.map((item,idx) => {
                                                                                let spanObj = getStatusSpan(item.assigmentTaskStatus,themeSettings);
                                                                                return <CustomTableRow themeSettings={themeSettings}
                                                                                className={item.disabled?"row-disable":""}>
                                                                                    <div className="table-cell" style={{width:"5%"}}>
                                                                                        <TableCheckBox onClick={this.handleStopPropagation}
                                                                                            themeSettings={themeSettings}>
                                                                                            <input 
                                                                                                type="checkbox"
                                                                                                name={idx+":-:"+id}
                                                                                                id={idx+":-:"+item.taskId}
                                                                                                onChange={this.handleSelectionTask}
                                                                                                disabled={item.disabled}
                                                                                                checked={item.isSelected?true:false}
                                                                                            />
                                                                                            <label for={idx+":-:"+item.taskId} 
                                                                                            style={{marginLeft:6}}></label>
                                                                                        </TableCheckBox>
                                                                                    </div>
                                                                                    <p style={{width:"5%",justifyContent:"center"}}>{(idx+1)}</p>
                                                                                    <p style={{width:"82%"}}>
                                                                                        {
                                                                                            this.state.taskTemplateValueMap &&
                                                                                            this.state.taskTemplateValueMap[item.taskId] &&
                                                                                            this.state.taskTemplateValueMap[item.taskId]["1"] &&
                                                                                            this.state.taskTemplateValueMap[item.taskId]["1"].value &&
                                                                                            <div className='task-dangerouslysethtml inner-html d-flex'
                                                                                                dangerouslySetInnerHTML={{__html: this.state.taskTemplateValueMap[item.taskId]["1"].value}} />
                                                                                        }
                                                                                        {
                                                                                            item.completionStatus==="Completed" &&
                                                                                            <span style={{marginLeft:6}}className="material-icons">done_all</span>
                                                                                        }
                                                                                        {
                                                                                            !isEmptyVariable(spanObj.spanText) &&
                                                                                            <span style={spanObj.spanStyle} className="span-tag">
                                                                                                {spanObj.spanText}
                                                                                            </span>
                                                                                        }
                                                                                    </p>
                                                                                    {/* <p style={{width:"30%"}}>
                                                                                        {isEmptyArray(item.employeeData)?"":
                                                                                            item.employeeData[0]?.employeeDetails?.firstName+" "+item.employeeData[0]?.employeeDetails?.lastName+" ("+item.employeeData[0]?.employeeDetails?.designation+")"
                                                                                        }
                                                                                    </p> */}
                                                                                    <p style={{width:"8%"}}>
                                                                                        {
                                                                                            item.added &&
                                                                                            <span class="material-icons"
                                                                                            style={{color:`rgba(${themeSettings.themeColor.r},${themeSettings.themeColor.g},${themeSettings.themeColor.b},${themeSettings.themeColor.a})`}}>check_circle</span>
                                                                                        }
                                                                                    </p>
                                                                                    
                                                                                </CustomTableRow>
                                                                            })
                                                                        }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        }
                                                    </Card.Body>
                                                </Accordion.Collapse>
                                            </Card>
                                        </Accordion>
                                        {
                                            this.state.componentDidMountFlag && isEmptyArray(processObj.taskList) &&
                                            <div class="no-items-layout">
                                                <div class="no-items-card" style={{padding:"10px"}}>
                                                    <h6 style={{margin:0}}>
                                                    {
                                                        Constants.NO_RECORDS_WARNING
                                                    }
                                                    </h6>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                })
                            }
                        </div>
                    </div>
                }
                <AlertDialog
                    showAlertDialog={this.state.showAlertDialogInfo}
                    handleAlertDialogClose={this.handleAlertDialogCloseInfo}
                    type={Constants.ALERT_TYPE_ALERT}
                    alertDialogMessage={this.state.alertDialogMessageInfo}
                    proceedBtnClick={this.handleAlertDialogCloseInfo}
                    proceedBtnLabel={Constants.ALERT_TYPE_OKAY_LABEL}
                    themeSettings={themeSettings}
                />
                <Modal className="task-select-table-dialog custom-dialog"
                    show={this.state.showAssignResourcesDialogFlag} 
                    backdrop="static">
                    <Modal.Header>
                        <h5>Assign Client</h5>
                        <button 
                            onClick={this.assignResourcesDialogClose}
                            type="button" data-dismiss="modal">
                            <span class="material-icons">close</span>
                        </button>
                    </Modal.Header>
                    <hr />
                    <div className="modal-body">
                        <div className="body-wrapper">
                            <div className="search-addnew-bg" style={{marginTop:0}}>
                                <div className="search-addnew">
                                    <div className="flex-center-layout">
                                        <div style={{ marginRight: 10 }}>
                                            <FilterDropDown
                                                placeholder={this.state.assignResourcesPlaceholder}
                                                dropdownArr={this.state.assigneResourcesFilterDropDownArr}
                                                onDropDownItemClick={this.assigneResourceFilterDropDownOnClick}
                                                themeSettings={themeSettings}
                                                name={"label"}
                                                dropdownWidth="200px"
                                            />
                                        </div>
                                        <div className="bordered-anchor"
                                        style={{marginRight:5}}>
                                            <a onClick={this.unSelectAllTasksResourcesDialog} href="javascript:void(0);">
                                                <span class="material-icons-outlined">
                                                check_box_outline_blank
                                                </span>
                                                <p>Unselect All</p>
                                            </a>
                                        </div>
                                        <div className="bordered-anchor"
                                        style={{marginRight:5}}>
                                            <a onClick={this.selectAllTasksResourcesDialog} href="javascript:void(0);">
                                                <span class="material-icons-outlined">
                                                check_box
                                                </span>
                                                <p>Select All</p>
                                            </a>
                                        </div>
                                        <div style={{width:"300px"}}>
                                            <RegularDropdown 
                                                placeholder={this.state.resourceDropdownPlaceholder}
                                                dropdownArr={this.state.employeesList}
                                                labelParam="fullName"
                                                onDropDownItemClick={this.resourceDropdownClick}
                                                defaultPlaceholderDropDown={resourceDropdownPlaceholder}
                                            />
                                        </div>
                                    </div>
                                    <div>
                                        <DialogSaveButton themeSettings={themeSettings} 
                                        onClick={this.onClickAddResourceToAssignment} type="button" 
                                        className="modal-save m-b-0">Assign</DialogSaveButton>
                                    </div>
                                </div>       
                            </div>
                            <div className="assign-taskresource accordion-layout" style={{position:"relative"}}>
                                {Object.values(isEmptyArray(this.state.assigneResourcesFilterDataList)?this.state.datalist:this.state.assigneResourcesFilterDataList)
                                .filter(processObj => processObj.taskList.some((item) => item.added === true))
                                .map((processObj,index)=>{
                                    let showTasks = false;
                                    let className;
                                    if (index === 0) {
                                        className = 'card-radius'; // CSS for the first item
                                    } else if (index === ((Object.values(isEmptyArray(this.state.assigneResourcesFilterDataList)?
                                        this.state.datalist:this.state.assigneResourcesFilterDataList))
                                        .filter(processObj => processObj.taskList.some((item) => item.added===true))).length - 1) {
                                        className = 'card-last'; // CSS for the last item
                                    } else {
                                        className = 'card-middle'; // CSS for all other items
                                    }
                                    let id = isEmptyVariable(processObj.processId) ? processObj.functionId : processObj.processId;
                                    // showTasks=!!processObj.taskList.find(({added}) =>added===true)
                                    showTasks=processObj.taskList.some((item) =>item.added===true)
                                    if(showTasks){
                                        return <div className="process-task-list">
                                            <Accordion style={{marginTop:index === 0?15:0}} activeKey={this.state.activeAssignResourceKey}>
                                                <Card className={className}> 
                                                    <Card.Header>
                                                        <Accordion.Toggle
                                                            as={Button}
                                                            variant="link"
                                                            eventKey={id}
                                                            onClick={() => this.handleAccordionToggleAssignResource(id)}
                                                        >
                                                            <div className='row align-items-center'>
                                                                <TableCheckBox
                                                                    themeSettings={themeSettings}>
                                                                    <input 
                                                                        type="checkbox"
                                                                        name={id}
                                                                        id={"RES"+id}
                                                                        onChange={this.handleSelectionProcessTasksInResourcesDialog}
                                                                        checked={processObj.isProcSelectedInResources?true:false}
                                                                    />
                                                                    <label for={"RES"+id} 
                                                                    style={{marginLeft:5}}></label>
                                                                </TableCheckBox> 
                                                                <h6 className='col-md-6 text-left'>{!isEmptyVariable(id)?processObj.processName:processObj.functionName}</h6>
                                                                {
                                                                    processObj.taskList.filter(item => item.added === true).length > 0 &&
                                                                    <h6 className='col-md-2 text-left'>{"Total Task: "+processObj.taskList.filter(item => item.added === true).length}</h6>
                                                                }
                                                                <h6 className='col-md-3 text-center'>{"Employee Assigned: "+processObj.taskList.filter(taskItem => !isEmptyVariable(taskItem.employeeFullName)).length}</h6>
                                                            </div>
                                                        </Accordion.Toggle>
                                                    </Card.Header> 
                                                    <Accordion.Collapse eventKey={id}>
                                                        <Card.Body>                                            
                                                            {
                                                                !isEmptyArray(processObj.taskList) && 
                                                                <div className="common-tab-bg">
                                                                    <div className="common-table" style={{width:"100%"}}>
                                                                        <table className="table">
                                                                            <thead>
                                                                                <tr>
                                                                                    <th className="text-center" width={"8%"}></th>
                                                                                    <th className="text-center" width={"5%"}>No.</th>
                                                                                    <th width={"55%"}>Tasks</th>
                                                                                    <th width={"33%"}>Employees</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                            {
                                                                                !isEmptyArray(processObj.taskList) &&
                                                                                (visibleRowNo => processObj.taskList.map((item,idx) => {
                                                                                    if(item.added){
                                                                                        visibleRowNo++;
                                                                                        return <tr>
                                                                                            <td>
                                                                                                <TableCheckBox
                                                                                                    themeSettings={themeSettings}>
                                                                                                    <input
                                                                                                        type="checkbox"
                                                                                                        name={idx+":-:"+id}
                                                                                                        id={idx+":-:"+"RES"+item.taskId}
                                                                                                        onChange={this.handleSelectionTaskInResourcesDialog}
                                                                                                        checked={item.isEmployeeTaskSelected?true:false}
                                                                                                    />
                                                                                                    <label for={idx+":-:"+"RES"+item.taskId}
                                                                                                    style={{marginLeft:6}}></label>
                                                                                                </TableCheckBox>
                                                                                            </td>
                                                                                            <td className="text-center">{visibleRowNo}</td>
                                                                                            <td>
                                                                                                <div className="flex-center-layout">
                                                                                                {
                                                                                                    this.state.taskTemplateValueMap &&
                                                                                                    this.state.taskTemplateValueMap[item.taskId] &&
                                                                                                    this.state.taskTemplateValueMap[item.taskId]["1"] &&
                                                                                                    this.state.taskTemplateValueMap[item.taskId]["1"].value &&
                                                                                                    <div className='task-dangerouslysethtml inner-html d-flex'
                                                                                                        dangerouslySetInnerHTML={{__html: this.state.taskTemplateValueMap[item.taskId]["1"].value}} />
                                                                                                }
                                                                                                {
                                                                                                    item.completionStatus==="Completed" &&
                                                                                                    <span style={{marginLeft:6,fontSize:18}}
                                                                                                    className="material-icons">done_all</span>
                                                                                                }
                                                                                                </div>
                                                                                            </td>
                                                                                            {/* <td>{isEmptyArray(item.employeeData)?"":
                                                                                                item.employeeData[0]?.employeeDetails?.firstName+" "+item.employeeData[0]?.employeeDetails?.lastName+" ("+item.employeeData[0]?.employeeDetails?.designation+")"
                                                                                            }</td> */}
                                                                                            <td>{isEmptyVariable(item.employeeFullName)?"":item.employeeFullName}</td>
                                                                                        </tr>
                                                                                    }
                                                                                }))(0)
                                                                            }
                                                                            </tbody>
                                                                        </table>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </Card.Body>
                                                    </Accordion.Collapse>
                                                </Card>
                                            </Accordion>
                                        </div>
                                    }
                                })
                            }
                            </div>
                        </div>
                    </div>
                </Modal>

                <Modal className="custom-dialog" show={this.state.showNextDateDialog} backdrop="static">
                    <Modal.Header>
                        <h5>{"Response Deadline Date"}</h5>
                        <button 
                            onClick={this.handleDateDialogClose}
                            type="button" data-dismiss="modal">
                            <span class="material-icons">close</span>
                        </button>
                    </Modal.Header>
                    <div class="modal-body">
                        <div className="addnew-modal-form">
                            <div class="addnew-modal-form-group">
                                <DatePicker
                                    onChange={this.onDateChange}
                                    value={!isEmptyVariable(this.state.deadlineDate)?moment(this.state.deadlineDate):null}
                                    format={"DD/MM/YYYY"}
                                    placeholder="Select Date"
                                    disabledDate={(current) => current.isBefore(moment().subtract(1,"day"))}
                                    // selectedItem={!isEmptyVariable(this.state.deadlineDate)?moment(this.state.deadlineDate):""}
                                    disabled={!isEmptyVariable(this.state.selectedOption)} // disable when radio selected
                                />
                            </div>
                            <div className='addnew-modal-form-group'>
                                <div className="radio-group radio-group-inline">
                                    <div style={{display: "flex", flexDirection: "row", gap: "20px", alignItems: "center"}}>
                                        <TableRadioButton
                                            key={'7'}
                                            style={{marginLeft:0, display:"flex", flexDirection: "column", alignItems: "center"}}
                                            themeSettings={themeSettings}
                                        >
                                            <input 
                                                type="radio"
                                                name="7"
                                                id={'7'}
                                                value={'7'}
                                                onChange={this.handleCheck}
                                                checked={this.state.selectedOption === "7"}
                                                disabled={!isEmptyVariable(this.state.deadlineDate)}
                                            />
                                            <label htmlFor={'7'} style={{marginLeft:0}}>7 Days</label>
                                        </TableRadioButton>
                                        <TableRadioButton
                                            key={'10'}
                                            style={{marginLeft:0, display:"flex", flexDirection: "column", alignItems: "center"}}
                                            themeSettings={themeSettings}
                                        >
                                            <input 
                                                type="radio"
                                                name="10"
                                                id={'10'}
                                                value={'10'}
                                                onChange={this.handleCheck}
                                                checked={this.state.selectedOption === "10"}
                                                disabled={!isEmptyVariable(this.state.deadlineDate)}
                                            />
                                            <label htmlFor={'10'} style={{marginLeft:0}}>10 Days</label>
                                        </TableRadioButton>
                                        <TableRadioButton
                                            key={'15'}
                                            style={{marginLeft:0, display:"flex", flexDirection: "column", alignItems: "center"}}
                                            themeSettings={themeSettings}
                                        >
                                            <input 
                                                type="radio"
                                                name="15"
                                                id={'15'}
                                                value={'15'}
                                                onChange={this.handleCheck}
                                                checked={this.state.selectedOption === "15"}
                                                disabled={!isEmptyVariable(this.state.deadlineDate)}
                                            />
                                            <label htmlFor={'15'} style={{marginLeft:0}}>15 Days</label>
                                        </TableRadioButton>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            this.state.errorMsg &&
                            <span className="cm-error dialog-error">{this.state.errorMsg}</span>
                        }

                        <div class="dialog-btn-layout">
                            <a class="alert-cancel" href="javascript:void(0);"
                                onClick={this.handleDateDialogClose}
                            >Cancel</a>
                            <a class="alert-cancel" href="javascript:void(0);"
                                onClick={this.handleClear}
                                style={{
                                    marginLeft:"10px"
                                }}
                            >Clear</a>
                            <DialogProceedButton
                                themeSettings={themeSettings}
                                class="alert-proceed"
                                href="javascript:void(0);"
                                onClick={this.handleProceedButtonClick}
                                style={{
                                    marginLeft:"10px"
                                }}
                            >
                                {this.state.showLoader ? <div class="loader-btn mt-2"></div> : "Save"}
                            </DialogProceedButton>
                        </div>
                    </div>
                </Modal>
            </Router>
        );
    }
}

export default ReAssignForResponse;